import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { GS1FileComponent, GS1LoadingService, GS1NotificationService } from "@gs1france/gs1-components-library";
import { FileService } from "src/app/core/services/file-service/file-service.service";
import { GLNService } from "src/app/core/services/gln/gln.service";
import { StorageService } from "src/app/core/services/storage/storage.service";
import { UploadResult } from "src/app/models/upload-results.model";
@Component({
  selector: 'import-export',
  templateUrl: './import-export.component.html',
  styleUrls: ['./import-export.component.scss']
})
export class ImportExportComponent implements OnInit {
  uploadForm!: FormGroup;
  sendingFile = false;
  uploadProgress = 0;
  progressTimer: any;
  fileName? : string;
  result?: UploadResult;

  wrongFileImported?: boolean;


  @ViewChild('file') gs1file!: GS1FileComponent;

  constructor(private glnService: GLNService, private loadingService: GS1LoadingService, private fb: FormBuilder, private fileService: FileService,
    private notifications: GS1NotificationService,
    private _storage: StorageService) {}

  /**
   * Initializes the upload form.
   * @returns None
   */
  ngOnInit(): void {
    this._storage.resetAccountPage();
    this.uploadForm = this.fb.group({
      file: [null, Validators.compose([Validators.minLength(1), Validators.maxLength(1), Validators.required])]
    });
  }

  /**
   * Gets the template file from the server.
   * @returns None
   */
  async getfile(){
    this.loadingService.startLoading('ifs');
    await this.glnService.getIfsFile();
    this.loadingService.stopLoading('ifs');
  }

  /**
   * Uploads the file to the server and displays the progress and results.
   * @returns None
   */
  async importFile() {
    if (this.uploadForm.valid) {
      this.sendingFile = true;
      this.startProgress();
      this.gs1file.files = [];
      try {
        this.result = await this.glnService.uploadGLNs(this.uploadForm.get('file')?.value);
        this.wrongFileImported = false;
        clearInterval(this.progressTimer);
        this.uploadProgress = 100;
        setTimeout(()=> {
          (document.getElementById('upload-result') as HTMLElement).scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"})
        }, 200);
      } catch (err: any) {
        if(err.status === 415){
          this.wrongFileImported = true;
        }
        clearInterval(this.progressTimer);
      } finally {
        this.uploadForm.get('file')?.setValue(null);
        this._storage.forceGLNRefresh = true;

        setTimeout(() => {
          this.sendingFile = false;
          this.uploadProgress = 0;
        }, 500);
      }
    }
  }

  /**
   * Sets the file to be used for display.
   * @param {any[]} file - the file to be used for display.
   * @returns None
   */
  setFile(file: any[]) {
    if (file && file[0]) {
      this.result = undefined;
      this.wrongFileImported = false;
      this.fileName = file[0].name;
    }
  }

  /**
   * Starts the progress bar.
   */
  startProgress() {
    this.progressTimer = setInterval(() => {
      if (this.uploadProgress < 30)
        this.uploadProgress += 1;
      else if (this.uploadProgress < 50)
        this.uploadProgress += 0.5
      else if (this.uploadProgress < 70)
        this.uploadProgress += 0.25
      else if (this.uploadProgress < 90)
        this.uploadProgress += 0.1
      else if (this.uploadProgress < 95)
        this.uploadProgress += 0.01
    }, 100)
  }

  /**
   * Downloads the result file if it exists.
   * @returns None
   */
  downloadResult() {
    if (this.result && this.result.file) {
      const name = this.fileName?.slice(0, this.fileName.length - 5) + ' - erreurs' + this.fileName?.slice(this.fileName.length - 5);
      this.fileService.downloadFile(this.result?.file, name);
    }
  }
}
